firebird.directive('fbSrcObject', [
    '$window',
    '$sce',
    'logService',
    'helperService',
    'executionEnvironmentEnum',
    function ($window, $sce, logService, helperService, executionEnvironmentEnum) {
        const logger = logService.createLoggerWithSource('fbSrcObject');
        const vdiRef = helperService.getVDIRef();

        return {
            restrict: 'A',
            scope: {
                mediaSource: '=fbSrcObject'
            },
            link: function (scope, element, attrs) {
                scope.$watch('mediaSource', function (newValue) {
                    var mediaStream = newValue;

                    if (vdiRef.getVdiType() !== executionEnvironmentEnum.NonVDI && element[0]) {
                        // for setup and cleanup using mapAudio/VideoElement.
                        if ($window.Janus.attachMediaStream) {
                            $window.Janus.attachMediaStream(element[0], mediaStream);
                            return;
                        } else if (newValue && element[0].nodeName === 'VIDEO') {
                            $window.Janus.videoElementIndex = vdiRef.mapVideoElement(
                                element[0],
                                $window.Janus.videoElementIndex
                            );
                            element[0].videoWidth = element[0].width;
                            element[0].videoHeight = element[0].height;
                        }
                    }
                    try {
                        element[0].srcObject = mediaStream;
                    } catch (error) {
                        logger.error(
                            'directive',
                            'Unable to use HTMLMediaElement.srcObject, falling back to use legacy API.',
                            error
                        );

                        element[0].src = mediaStream
                            ? $sce.trustAsResourceUrl($window.URL.createObjectURL(mediaStream))
                            : null;
                    }
                });
            }
        };
    }
]);
